import React from 'react'
import RetourCourt from '../components/RetourCourt'


function LumiereResume() {
  return (
    <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Tandis que dehors une menace mortelle approche, la troupe d’un cirque se prépare à jouer son dernier spectacle.</p>
    </div>
    <div style={{textAlign:"center"}}> <RetourCourt /></div>
    </div>
  )
}

export default LumiereResume
